import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        currentUserToken: localStorage.getItem('access_token') || null,
        currentUserAdditionData: localStorage.getItem('user_add_data') || null,
        currentUserRemainingData: localStorage.getItem('user_remain_data') || null,
        currentUserUsedData: localStorage.getItem('user_used_data') || null,
        currentUserBalance: localStorage.getItem('user_balance') || null,
        currentUserPhoneData: localStorage.getItem('user_phone_data') == null ? [] : JSON.parse(localStorage.getItem('user_phone_data')),
        currentUserDetail: localStorage.getItem('user_detail') == null ? [] : JSON.parse(localStorage.getItem('user_detail')),
        currentUserTable: localStorage.getItem('user_table') == null ? [] : JSON.parse(localStorage.getItem('user_table')),
        currentUserFee: localStorage.getItem('user_fee') == null ? [] : JSON.parse(localStorage.getItem('user_fee')),
        currentUserFeeLast: localStorage.getItem('user_fee_last') == null ? [] : JSON.parse(localStorage.getItem('user_fee_last')),
        currentUserInvoice: localStorage.getItem('user_invoice') == null ? [] : JSON.parse(localStorage.getItem('user_invoice')),
        currentOptions: localStorage.getItem('user_options') == null ? [] : JSON.parse(localStorage.getItem('user_options')),
        currentPayments: localStorage.getItem('user_payments') == null ? [] : JSON.parse(localStorage.getItem('user_payments')),
        currentSelected: localStorage.getItem('user_selected')
    },
    mutations: {
        // actions for syncrous methods
        setToken(state, token) {
            state.currentUserToken = token
        },
        setAddData(state, add) {
            state.currentUserAdditionData = add
        },
        setRemainData(state, remain) {
            state.currentUserRemainingData = remain
        },
        setUsedData(state, used) {
            state.currentUserUsedData = used
        },
        setBalance(state, balance) {
            state.currentUserBalance = balance
        },
        setPhoneData(state, phone) {
            state.currentUserPhoneData = phone
        },
        setUserDetail(state, detail) {
            state.currentUserDetail = detail
        },
        setUserTable(state, table) {
            state.currentUserTable = table
        },
        setUserFee(state, fee) {
            state.currentUserFee = fee
        },
        setUserFeeLast(state, last) {
            state.currentUserFeeLast = last
        },
        setOptions(state, options) {
            state.currentOptions = options
        },
        setPayments(state, payments) {
            state.currentPayments = payments
        },
        setSelected(state, selected) {
            state.currentSelected = selected
        },
        setInvoice(state, invoice) {
            state.currentUserInvoice = invoice
        },
        destroyToken(state) {
            state.currentUserToken = null
            state.currentUserAdditionData = null
            state.currentUserRemainingData = null
            state.currentUserUsedData = null
            state.currentUserBalance = null
            state.currentUserPhoneData = []
            state.currentUserDetail = {}
            state.currentUserTable = []
            state.currentUserFee = {}
            state.currentUserFeeLast = {}
            state.currentOptions = []
            state.currentPayments = []
            state.currentSelected = null,
                state.currentUserInvoice = []
        }
    },
    actions: {
        // actions for asyncronous methods
        retrieveToken(context, credentials) {
            localStorage.setItem('access_token', credentials.userToken)
            context.commit('setToken', credentials.userToken)
        },
        retrieveAddData(context, credentials) {
            localStorage.setItem('user_add_data', credentials.addData)
            context.commit('setAddData', credentials.addData)
        },
        retrieveRemainData(context, credentials) {
            localStorage.setItem('user_remain_data', credentials.remainData)
            context.commit('setRemainData', credentials.remainData)
        },
        retrieveUsedData(context, credentials) {
            localStorage.setItem('user_used_data', credentials.usedData)
            context.commit('setUsedData', credentials.usedData)
        },
        retrieveBalance(context, credentials) {
            localStorage.setItem('user_balance', credentials.balance)
            context.commit('setBalance', credentials.balance)
        },
        retrievePhoneData(context, credentials) {
            localStorage.setItem('user_phone_data', JSON.stringify(credentials.phoneData))
            context.commit('setPhoneData', credentials.phoneData)
        },
        retrieveUserDetail(context, credentials) {
            localStorage.setItem('user_detail', JSON.stringify(credentials.userDetail))
            context.commit('setUserDetail', credentials.userDetail)
        },
        retrieveUserTable(context, credentials) {
            localStorage.setItem('user_table', JSON.stringify(credentials.userTable))
            context.commit('setUserTable', credentials.userTable)
        },
        retrieveUserFee(context, credentials) {
            localStorage.setItem('user_fee', JSON.stringify(credentials.userFee))
            context.commit('setUserFee', credentials.userFee)
        },
        retrieveUserFeeLast(context, credentials) {
            localStorage.setItem('user_fee_last', JSON.stringify(credentials.userFeeLast))
            context.commit('setUserFeeLast', credentials.userFeeLast)
        },
        retrieveOptions(context, credentials) {
            localStorage.setItem('user_options', JSON.stringify(credentials.options))
            context.commit('setOptions', credentials.options)
        },
        retrievePayments(context, credentials) {
            localStorage.setItem('user_payments', JSON.stringify(credentials.payments))
            context.commit('setPayments', credentials.payments)
        },
        retrieveSelected(context, credentials) {
            localStorage.setItem('user_selected', JSON.stringify(credentials.selected))
            context.commit('setSelected', credentials.selected)
        },
        retrieveInvoice(context, credentials) {
            localStorage.setItem('user_invoice', JSON.stringify(credentials.invoice))
            context.commit('setInvoice', credentials.invoice)
        },
        destroyToken(context) {
            localStorage.removeItem('access_token')
            localStorage.removeItem('user_add_data')
            localStorage.removeItem('user_remain_data')
            localStorage.removeItem('user_used_data')
            localStorage.removeItem('user_balance')
            localStorage.removeItem('user_phone_data')
            localStorage.removeItem('user_detail')
            localStorage.removeItem('user_table')
            localStorage.removeItem('user_fee')
            localStorage.removeItem('user_fee_last')
            localStorage.removeItem('user_options')
            localStorage.removeItem('user_payments')
            localStorage.removeItem('user_selected')
            localStorage.removeItem('user_invoice')
            context.commit('destroyToken')
        }
    },
    modules: {},
    getters: {
        loggedIn(state) {
            return state.currentUserToken != null;
        },
        userAdditionData(state) {
            return state.currentUserAdditionData;
        },
        userRemainingData(state) {
            return state.currentUserRemainingData;
        },
        userUsedData(state) {
            return state.currentUserUsedData;
        },
        userBalance(state) {
            return state.currentUserBalance;
        },
        userToken(state) {
            return state.currentUserToken;
        },
        userPhoneData(state) {
            return state.currentUserPhoneData;
        },
        userDetail(state) {
            return state.currentUserDetail;
        },
        userTable(state) {
            return state.currentUserTable;
        },
        userFee(state) {
            return state.currentUserFee;
        },
        userFeeLast(state) {
            return state.currentUserFeeLast;
        },
        userInvoice(state) {
            return state.currentUserInvoice;
        },
        options(state) {
            return state.currentOptions;
        },
        payments(state) {
            return state.currentPayments;
        },
        selected(state) {
            return state.currentSelected;
        }
    }
})